import { connect } from 'react-redux';
import AuctionsManagementEditPage from './AuctionsManagementEditPage';
import {
  commonMapStateToProps,
  commonMapDispatchToProps,
  commonMergeProps,
} from './commonAuctionsContainer';

const mapStateToProps = state => {
  return {
    ...commonMapStateToProps(state),
    routes: state.dictionary.static.routes,
    zipCodes: state.dictionary.static.zipCodes,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    ...commonMapDispatchToProps(dispatch),
  };
};

const mergeProps = (propsFromState, propsFromDispatch, ownProps) => {
  return {
    ...propsFromState,
    ...propsFromDispatch,
    ...ownProps,
    ...commonMergeProps(propsFromState, propsFromDispatch, ownProps),
  };
};

const AuctionsManagementEditPageContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(AuctionsManagementEditPage);

export default AuctionsManagementEditPageContainer;
